import React from 'react';
import {StyledBasedSelect} from "./selectStyles";
import {GreenSelectArrow, RedArrow} from "../../assets/images";

const BasedSelect = ({value, children, onChange, isChanged, isDisabled = false,isselected}: any) => {
    return (
        <StyledBasedSelect
            disabled={isDisabled}
            bordered={false}
            size="small"
            suffixIcon={(isChanged) ? <RedArrow/> : <GreenSelectArrow/>}
            defaultValue={value}
            onChange={onChange}
            ischanged={isChanged}
            isselected={isselected}
        >
            {children}
        </StyledBasedSelect>


    );
};

export {BasedSelect};
